// import axios from 'axios'

// import { getMetaContent } from '../../helpers'
import { buildMikasaClient } from '../../helpers/api'

export const getListingEvaluationByAddressAndPrice = async (
  authSettings,
  address,
  price,
  appreciationSliderPercent,
  includeRental = false
) => {
  const client = await buildMikasaClient(authSettings)

  let params = {
    raw_address: address,
    listing_price: price,
  }

  if (appreciationSliderPercent) {
    params = {
      ...params,
      tuned_appreciation_percent: appreciationSliderPercent,
    }
  }

  if (includeRental) {
    params = { ...params, include_rental: includeRental }
  }

  const endpoint = `/chromebot/listing_evaluation?${new URLSearchParams(
    params
  )}`

  const response = await client.get(endpoint)

  return response?.data
}

export const getAppreciationIndicatorByAddressAndPrice = async (
  authSettings,
  address,
  price
) => {
  const client = await buildMikasaClient(authSettings)
  const endpoint = `/chromebot/annual_appreciation_percent?${new URLSearchParams(
    {
      raw_address: address,
      listing_price: price,
    }
  )}`

  const response = await client.get(endpoint)

  return response?.data
}

export const getMarketTempIndicatorByAddressAndPrice = async (
  authSettings,
  address,
  price
) => {
  const client = await buildMikasaClient(authSettings)
  const endpoint = `/chromebot/market_temp?${new URLSearchParams({
    raw_address: address,
    listing_price: price,
  })}`

  const response = await client.get(endpoint)

  return response?.data
}

export const getListingRentalPotentialByAddress = async (
  authSettings,
  address
) => {
  const client = await buildMikasaClient(authSettings)
  const endpoint = `/chromebot/rental_potential?${new URLSearchParams({
    raw_address: address,
  })}`

  const response = await client.get(endpoint)

  return response?.data
}
